import { render, staticRenderFns } from "./SideCenterShareSlides.vue?vue&type=template&id=0e54fb64&scoped=true&"
import script from "./SideCenterShareSlides.vue?vue&type=script&lang=js&"
export * from "./SideCenterShareSlides.vue?vue&type=script&lang=js&"
import style0 from "./SideCenterShareSlides.vue?vue&type=style&index=0&id=0e54fb64&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e54fb64",
  null
  
)

export default component.exports